import React from 'react'
import * as R from 'remeda'

type CreateRestoringParams = (hash: string) => unknown

const CreateRestoringParamsContext = React.createContext<CreateRestoringParams>(
  R.doNothing,
)

export type CreateRestoringParamsProviderProps = React.PropsWithChildren<{
  createRestoringParams: CreateRestoringParams
}>

export const CreateRestoringParamsProvider = ({
  children,
  createRestoringParams,
}: CreateRestoringParamsProviderProps) => (
  <CreateRestoringParamsContext.Provider value={createRestoringParams}>
    {children}
  </CreateRestoringParamsContext.Provider>
)

export const useRestoringParams = (hash: string) => {
  const createRestoringParams = React.useContext(CreateRestoringParamsContext)

  return React.useMemo(
    () => createRestoringParams(hash),
    [createRestoringParams, hash],
  )
}
